'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "minutes" on Range.prototype.


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/minutes.js
// module id = 865
// module chunks = 0